export const createDecisionMakingSlice = (set) => ({
  decisionMakingResponse: {},
  storeDecisionMakingResponse: (values) => set({ decisionMakingResponse: values }),
  clearDecisionMakingResponse: () => set({ decisionMakingResponse: [] }),
});
